// PIN přihlášení — „Noční kokpit" (prototyp 1:1): wordmark, čtyři kruhy Ø38,
// klávesnice 1–9 / C / 0 / ⌫. Auto-submit po 4 číslicích; chyba = červené
// kruhy + zatřesení. Logika (authStore.login) beze změny.

import { useState } from "react";
import { IonContent, IonPage } from "@ionic/react";
import { useAuthStore } from "../store/authStore";
import { ThemeToggle } from "../components/ThemeToggle";

export function LoginScreen() {
  const [pin, setPin] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [shake, setShake] = useState(false);
  const login = useAuthStore((s) => s.login);

  const handleDigit = (d: string) => {
    if (submitting || pin.length >= 4) return;
    const newPin = pin + d;
    setPin(newPin);
    setError(null);
    if (newPin.length === 4) void submit(newPin);
  };

  const handleBackspace = () => {
    if (submitting) return;
    setPin((p) => p.slice(0, -1));
    setError(null);
  };

  const handleClear = () => {
    if (submitting) return;
    setPin("");
    setError(null);
  };

  const submit = async (finalPin: string) => {
    setSubmitting(true);
    try {
      await login(finalPin);
    } catch (e: any) {
      setError(e?.message ?? "Nesprávný PIN");
      setShake(true);
      setTimeout(() => {
        setShake(false);
        setPin("");
      }, 650);
    } finally {
      setSubmitting(false);
    }
  };

  // Stav kruhu: chyba = všechny červené; jinak vyplněné zlaté.
  const slotClass = (i: number) => {
    if (error) return "ps bad";
    return pin.length > i ? "ps fill" : "ps";
  };

  return (
    <IonPage>
      <IonContent scrollY={false}>
        <div className="ck scenebg" style={{ height: "100%" }}>
          <ThemeToggle float />
          <div className="lg">
            <div className="wordmark">ROUTERA <em>DRIVER</em></div>
            <div className="sub">C.I.T Lama</div>

            <div className="pingroup">
              <div className="pin-label">Zadejte PIN</div>
              <div
                className={`pinslots${shake ? " err" : ""}`}
                role="status"
                aria-label={`Zadáno ${pin.length} ze 4 číslic`}
              >
                {[0, 1, 2, 3].map((i) => (
                  <div key={i} className={slotClass(i)} />
                ))}
              </div>
              <div className={error ? "who-name login-err" : "who-name"} role={error ? "alert" : undefined}>
                {submitting ? "Přihlašuji…" : error ?? ""}
              </div>
            </div>

            <div className="pad">
              {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map((d) => (
                <button key={d} className="key" onClick={() => handleDigit(d)} disabled={submitting} aria-label={d}>
                  {d}
                </button>
              ))}
              <button
                className="key"
                onClick={handleClear}
                disabled={submitting || pin.length === 0}
                aria-label="Smazat vše"
                style={{ fontSize: 19, color: "var(--soft)" }}
              >
                C
              </button>
              <button className="key" onClick={() => handleDigit("0")} disabled={submitting} aria-label="0">
                0
              </button>
              <button
                className="key"
                onClick={handleBackspace}
                disabled={submitting || pin.length === 0}
                aria-label="Smazat poslední"
              >
                <svg viewBox="0 0 24 24">
                  <path d="M8.5 5h11A1.5 1.5 0 0 1 21 6.5v11a1.5 1.5 0 0 1-1.5 1.5h-11L3 12l5.5-7z" />
                  <path d="M12 9.5l5 5M17 9.5l-5 5" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}
